import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchLabels } from "../../redux/Slice/Contacts/labelsSlice";

const AddBroadcastModal = ({ open, onClose, onCreate }) => {
  const dispatch = useDispatch();
  const { labels } = useSelector((state) => state.labels);

  const [broadcastName, setBroadcastName] = useState("");
  const [label, setLabel] = useState("");

  useEffect(() => {
    if (open) {
      dispatch(fetchLabels());
    }
  }, [open, dispatch]);

  const handleClose = () => {
    setBroadcastName("");
    setLabel("");
    onClose();
  };

  const handleCreate = () => {
    if (!broadcastName.trim()) return;
    onCreate({ name: broadcastName.trim(), label: label.trim() || null });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Add Broadcast</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          label="Broadcast Name"
          value={broadcastName}
          onChange={(e) => setBroadcastName(e.target.value)}
          fullWidth
          required
          margin="normal"
        />
        <Autocomplete
          freeSolo
          options={labels}
          value={label}
          onInputChange={(_, newValue) => setLabel(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Label"
              margin="normal"
              helperText="Optional — applies this label to every contact in this broadcast. Pick an existing one or type a new one."
            />
          )}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleCreate}
          variant="contained"
          disabled={!broadcastName.trim()}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddBroadcastModal;
